// ==============================|| OVERRIDES - TOOLTIP ||============================== //

export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[700],
          fontSize: '0.75rem',
          padding: '8px 12px',
          borderRadius: '6px'
        },
        arrow: {
          color: theme.palette.grey[700]
        }
      }
    }
  };
}
